import { type ReactElement } from 'react';
import FeaturePageLayout from '../../components/features/FeaturePageLayout';

export default function Auftraege(): ReactElement {
  return (
    <FeaturePageLayout
      badge="Buchhaltung"
      title="Aufträge & Angebote professionell erstellen"
      subtitle="Erstellen Sie überzeugende Angebote und wandeln Sie diese mit einem Klick in Aufträge und Rechnungen um. Der komplette Workflow in einer Software."
      heroImage="/screenshots/hero-angebot-erstellen.webp"
      heroImageAlt="Saldify Angebotseditor mit Kleinunternehmer-Hinweis nach §19 UStG, Positionen und Gesamtsumme"
      features={[
        {
          title: 'Professionelle Angebote',
          description: 'Erstellen Sie Angebote mit Ihrem Branding, die Kunden überzeugen.',
        },
        {
          title: 'Ein-Klick-Umwandlung',
          description: 'Wandeln Sie Angebote in Aufträge und Aufträge in Rechnungen mit einem Klick um.',
        },
        {
          title: 'Angebotsverfolgung',
          description: 'Sehen Sie, ob Ihr Angebot geöffnet wurde und wann eine Antwort überfällig ist.',
        },
        {
          title: 'Digitale Unterschrift',
          description: 'Kunden können Angebote digital akzeptieren – rechtssicher und schnell.',
        },
        {
          title: 'Vorlagen speichern',
          description: 'Erstellen Sie Vorlagen für häufige Angebote und sparen Sie Zeit.',
        },
        {
          title: 'Auftragsbestätigung',
          description: 'Senden Sie automatisch Auftragsbestätigungen nach Annahme des Angebots.',
        },
      ]}
      sections={[
        {
          title: 'Vom Angebot zur Rechnung',
          description: 'Der nahtlose Workflow in Saldify: Erstellen Sie ein Angebot, der Kunde akzeptiert, Sie erstellen den Auftrag und am Ende die Rechnung – alles verknüpft und nachvollziehbar.',
          image: '/screenshots/hero-angebot-erstellen.webp',
          imageAlt: 'Neues Angebot anlegen: Empfänger, Gültigkeitsdatum und Positionen',
          bullets: [
            'Angebot erstellen und versenden',
            'Kunde akzeptiert digital',
            'Auftrag wird angelegt',
            'Rechnung mit allen Daten erstellen',
          ],
          imageSide: 'right',
        },
        {
          title: 'Angebote nachverfolgen',
          description: 'Verpassen Sie keine Verkaufschance. Saldify zeigt Ihnen, welche Angebote offen sind und erinnert Sie an überfällige Nachfassaktionen.',
          bullets: [
            'Status: Gesendet, Gelesen, Akzeptiert',
            'Lesebestätigung per E-Mail',
            'Erinnerung bei überfälligen Angeboten',
            'Erfolgsquote analysieren',
          ],
          imageSide: 'left',
        },
      ]}
      ctaTitle="Erstellen Sie Ihr erstes Angebot"
      ctaDescription="Überzeugen Sie Ihre Kunden mit professionellen Angeboten und beschleunigen Sie Ihren Verkaufsprozess."
    />
  );
}
